import { useEffect, useRef } from 'react';
import { useMap } from '../../contexts/MapContext';

// Plays the Zelda secret-door chime any time a secret door transitions from
// hidden to revealed, on every view at the table. Renders nothing.
// Mount once inside <MapProvider>.

const SOUND_SRC = '/audio/zelda_secret_sound.mp3';

export default function SecretDoorSoundWatcher() {
  const { doors } = useMap();
  const prevRevealedRef = useRef(null);
  const audioRef = useRef(null);

  useEffect(() => {
    // Lazy-init the Audio element so SSR / first paint doesn't trigger it.
    if (!audioRef.current) {
      audioRef.current = new Audio(SOUND_SRC);
      audioRef.current.preload = 'auto';
    }

    const revealed = new Set();
    for (const d of doors || []) {
      if (d?.type === 'secret' && d.secretRevealed) revealed.add(d.id);
    }
    const prev = prevRevealedRef.current;
    if (prev) {
      for (const id of revealed) {
        if (!prev.has(id)) {
          // New reveal — chime once. Catch autoplay rejection silently;
          // it'll succeed on the next user interaction.
          try {
            const a = audioRef.current.cloneNode();
            a.play().catch(() => {});
          } catch { /* noop */ }
        }
      }
    }
    prevRevealedRef.current = revealed;
  }, [doors]);

  return null;
}
